import { CharacterFormFields } from "@/pages/CreateCharacter/v2/types";

import { ROUTES } from "./navigation";

export const TAGS_TO_EXCLUDE = {
  STEP_FAMILY: "Step-Family",
  NSFW: "NSFW",
  SCAT: "Scat",
};

export const NSFW_TAGS = ["NSFW", "Oral", "Vore", "Flatulence", "Masochistic", "Watersport", "CNC", "Impregnation", "Lactation", "Anal"];

/** Typesense `filter_by` fragment excluding NSFW hits (flag false + none of the NSFW tags). */
export const NSFW_EXCLUSION_FILTER = `is_nsfw:false && tags:![${NSFW_TAGS.join(",")}]`;

/** Trending sort used across character/rulebook listing searches. */
export const NUM_MESSAGES_24H_DESC_SORT = "num_messages_24h:desc";

export const SUGGEST_TAG_EVENT_NAME = "character_suggest_tags";

export const MINIMUM_TAG_LIMIT = 2;
export const MINIMUM_TAG_ERROR_MESSAGE = "Select at least 2 tags";
export const MINIMUM_TAG_VALIDATION_MESSAGE = "At least 2 tags required";
export const MAXIMUM_TAG_LIMIT = 12;
export const DRAFT_LOCAL_STORAGE_KEY = "draft_character";
export const getDraftStorageKey = (userId?: string | null): string => {
  return userId ? `${DRAFT_LOCAL_STORAGE_KEY}_${userId}` : `${DRAFT_LOCAL_STORAGE_KEY}_guest`;
};
export const GROUP_CHAT_DRAFT_LOCAL_STORAGE_KEY = "draft_group_chat";
export const MY_CHATBOT_PAGE_ROUTE = ROUTES.chatbots;
export const DRAFT_PAGE_ROUTE = ROUTES.chatbotsDrafts;

export const RESTRICTED_MODAL = {
  contactUsLinkText: "Please contact us.",
  title: "Restricted!",
  confirmationMessage:
    "Your account currently has restricted access. You can continue to chat, but uploading and editing bots is temporarily disabled. For more information, ",
};

export const CHARACTER_FAVORITE_LIMIT = {
  code: "character_favorite_limit",
  message:
    "Oops! You've reached your limit of {{character_favorite_limit}} favorite bots. To add more, please consider removing some from your current list.",
};

export const DEFAULT_QUERY_BY_FOR_SEARCH_CLIENT = "name,title,tags,creator_username,character_id,type";
export const DEFAULT_QUERY_BY_FOR_SEARCH_CLIENT_LOREBOOKS = "name,tags,lorebook_id";
export const DEFAULT_INCLUDE_FIELDS_FOR_SEARCH_CLIENT =
  "name,title,tags,creator_username,character_id,avatar_is_nsfw,avatar_url,visibility,definition_visible,num_messages,token_count,rating_score,lora_status,creator_user_id,is_nsfw,type,sub_characters_count,group_size_category,has_lorebooks,voice_id,group_addable";
export const DEFAULT_INCLUDE_FIELDS_FOR_SEARCH_CLIENT_LOREBOOKS =
  "name,lorebook_id,tags,creator_username,creator_user_id,avatar_url,visibility,is_nsfw,avatar_is_nsfw,num_entries,description";
/**
 * Public Rulebooks index (WS2D). The document is expected to carry: rulebook_id, name, description, tags,
 * creator_username, creator_user_id, cover_url, cover_is_nsfw, is_nsfw, visibility, num_meters, application_ids and
 * createdAt (sort) — the same shape as the lorebooks index.
 */
export const DEFAULT_QUERY_BY_FOR_SEARCH_CLIENT_RULEBOOKS = "name,tags,rulebook_id";
export const DEFAULT_INCLUDE_FIELDS_FOR_SEARCH_CLIENT_RULEBOOKS =
  "name,rulebook_id,description,tags,creator_username,creator_user_id,cover_url,cover_is_nsfw,is_nsfw,visibility,moderation_status,status,moderation_report_status,definition_visible,num_meters,num_rules,num_hidden_meters,meter_chips,num_attached_characters,num_attached_personas";
export const SEARCH_CLIENT_INITIAL_VISIBLE_PAGE_COUNT = 10;

export const NSFW_TOGGLE_LOCALSTORAGE_KEY = "nsfwToggle";

export const TAG_SUGGESTION_KEY = "suggested_tags";

export const AVATAR_GENERATOR_MODEL_LOCAL_STORAGE_KEY = "avatar_generator_model";
export const AVATAR_GENERATOR_STYLE_LOCAL_STORAGE_KEY = "avatar_generator_style";

export const FREE_CHARACTER_ID = "65278037-0b5b-4547-bea3-582618f3e6fa";

export const ADVANCED_SECTION_KEY = "advanced";

export const HOME_LAST_CLICKED_CHARACTER_SESSION_STORAGE_KEY = "home-last-clicked-character";

export const CHARACTER_SCENARIO_DIALOGUE_MIN_LENGTH = 3;
export const CHARACTER_SCENARIO_DIALOGUE_MAX_LENGTH = 4000;

export const CHARACTER_FORM_VALIDATION_SCHEMA = {
  [CharacterFormFields.NAME]: {
    maxLength: 20,
  },
  [CharacterFormFields.TITLE]: {
    maxLength: 100,
  },
  [CharacterFormFields.GREETING]: {
    maxLength: 2000,
  },
  [CharacterFormFields.PERSONA]: {
    maxLength: 5000,
  },
  [CharacterFormFields.SCENARIO]: {
    maxLength: CHARACTER_SCENARIO_DIALOGUE_MAX_LENGTH,
  },
  [CharacterFormFields.DIALOGUE]: {
    maxLength: CHARACTER_SCENARIO_DIALOGUE_MAX_LENGTH,
  },
};
